import { render, staticRenderFns } from "./NeoparentVisitOverview.vue?vue&type=template&id=bf011866&scoped=true"
import script from "./NeoparentVisitOverview.vue?vue&type=script&lang=js"
export * from "./NeoparentVisitOverview.vue?vue&type=script&lang=js"
import style0 from "./NeoparentVisitOverview.vue?vue&type=style&index=0&id=bf011866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf011866",
  null
  
)

export default component.exports